import React, { Component } from "react";

import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';

import Shimmer from "./Shimmer";

import s from "../Home/HomeItem/HomeItem.css";
import l from "./Skeleton.css";

function HomeSliderSkleton() {

  return (
    <div className={cx('skeletonViewCard')}>
      <div className={cx(l.parentBgColor)}>
        <div className={cx(s.content, s.sliderBgSkleton)}>
          <Shimmer />
        </div>
        <div className={cx(l.skeletonTopBox)}>
          <Shimmer />
        </div>
        <div className={cx(l.skeletonDescBox)}>
          <div className={cx(l.skeletonContent)}>
          </div>
          <div className={cx(l.skeletonContent)}>
          </div>
          <div className={cx(l.skeletonContent)} style={{ width: '55%' }}>
          </div>
          <div className={cx(l.skeletonContentButton)}>
            <Shimmer />
          </div>
        </div>
      </div>

    </div>
  );
}

export default withStyles(s, l)(HomeSliderSkleton);

